export default __webpack_public_path__ + "static/equipo-gabi-Color-254310dc976f875d1cf2afd9d02f69db.png";